"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const react_toastify_1 = require("react-toastify");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const table_1 = require("../../../common/js/helper/table");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const ProductType_1 = __importDefault(require("../../enums/ProductType"));
const license_1 = require("../../helper/license");
const media_1 = require("../../helper/media");
const product_1 = require("../../helper/product");
const softwareColumns_1 = require("../../helper/softwareColumns");
const Activities_1 = __importDefault(require("../../stores/Activities"));
const LicenseStore_1 = __importDefault(require("../../stores/LicenseStore"));
const ChangeLicenseContactModal_1 = __importDefault(require("../ChangeLicenseContactModal"));
const ChangeUsageInformationModal_1 = __importDefault(require("../ChangeUsageInformationModal"));
const SoftwareActivateLicenceModal_1 = __importDefault(require("../SoftwareActivateLicenceModal"));
const TableSub_1 = __importDefault(require("../TableSub"));
class AssetsSoftwareTableExpandedItem extends react_1.default.Component {
    rowElementRef = react_1.default.createRef();
    externalId = (0, table_1.mustTextBeShortened)(this.props.data)
        ? (0, string_1.ellipsis)(this.props.data.externalId, 5)
        : this.props.data.externalId;
    componentDidMount() {
        if (this.props.data?.id === this.props.match.params.softwareId && !!this.rowElementRef.current) {
            this.rowElementRef.current.parentElement?.previousElementSibling?.scrollIntoView(true);
        }
    }
    render() {
        const { data } = this.props;
        const type = (0, string_1.slugifyKey)(data?.productType);
        const subtableLicenses = this.getSubtableLicenses(data);
        const isMindProduct = (0, license_1.isMindProductType)(type);
        const downloadAvailable = !!subtableLicenses &&
            subtableLicenses.some((license) => !!license.fileName && !(isMindProduct && (0, license_1.isSoftLock)(data?.lockType)));
        const detailColumns = (0, softwareColumns_1.getSoftwareDetailColumns)(type, data?.lockType);
        const infoText = this.props.t('myassets.software.table.license_refresh_notice', { type });
        // To trigger the observable values.
        LicenseStore_1.default.deactivateEllipsis.length;
        return (react_1.default.createElement("div", { className: "znd-assets-table-sub", ref: this.rowElementRef },
            react_1.default.createElement("div", { className: "d-flex flex-row" },
                data?.media ? (react_1.default.createElement("img", { className: "znd-assets-table-sub__image", ...(0, media_1.imageSourceFromMedia)(data.media) })) : null,
                subtableLicenses ? (react_1.default.createElement(TableSub_1.default, { columns: detailColumns, data: subtableLicenses, className: "znd-assets-table-sub__table" })) : null),
            !!infoText && !!subtableLicenses ? react_1.default.createElement("div", { className: "znd-assets-table-sub__info" }, infoText) : null,
            react_1.default.createElement("div", { className: "znd-assets-table-sub__buttons" },
                react_1.default.createElement("div", { className: "znd-assets-table-sub__button-wrapper" }, downloadAvailable ? (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_DOWNLOAD] },
                    react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: this.props.t('myassets.software.btn.download_license.title') ?? '', icon: Zupicons_1.default.download, loading: LicenseStore_1.default.isDownloading, disabled: LicenseStore_1.default.isDownloading, onClick: () => {
                            (0, product_1.prepareDownloadLicenses)(data);
                        } }))) : (!!data && (0, license_1.needsActivation)(data)) ||
                    (!!data?.activationUrl && ProductType_1.default.PRIMECENTER !== type) ? (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_ACTIVATE] },
                    react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: this.props.t(`myassets.software.btn.${!data?.activationUrl ||
                            ProductType_1.default.PRIMECENTER === type ||
                            (isMindProduct && (0, license_1.isSoftLock)(data?.lockType))
                            ? 'activate_license'
                            : 'activate_manage_license'}.title`) ?? '', icon: Zupicons_1.default.check, onClick: () => {
                            if (!(0, license_1.needsActivation)(data) && data?.activationUrl) {
                                window.open(data.activationUrl);
                                return;
                            }
                            (0, GlobalModal_1.showModal)({
                                component: SoftwareActivateLicenceModal_1.default,
                                props: {
                                    licenseId: data.id,
                                    productType: type,
                                    lockType: data.lockType,
                                },
                            }).then((event) => {
                                (0, product_1.updateConsented)(data.id);
                                Activities_1.default.save({
                                    topic: 'consent_activate_license',
                                    objectReference: {
                                        shopId: data.id,
                                        zundId: data.externalId,
                                        name: data.name,
                                    },
                                    data: {
                                        machineShopId: data.massiveMachine?.id,
                                        machineZundId: data.massiveMachine?.externalId,
                                    },
                                });
                                LicenseStore_1.default.setDeactivateEllipsis(data.id);
                                if ('action' === event &&
                                    !!data.activationUrl &&
                                    ProductType_1.default.PRIMECENTER !== type) {
                                    window.open(data.activationUrl);
                                    return;
                                }
                                if ('clipboard' === event &&
                                    (ProductType_1.default.ZUND_CUT_CENTER === type ||
                                        (isMindProduct && (0, license_1.isSoftLock)(data.lockType)))) {
                                    LicenseStore_1.default.setTmpActivated(data);
                                    navigator.clipboard.writeText(data.externalId).then(() => {
                                        react_toastify_1.toast.success((0, translation_1.t)('modal.software_activate_licence.copied', {
                                            product_type: type,
                                        }));
                                    });
                                    return;
                                }
                                react_toastify_1.toast.success((0, translation_1.t)('modal.software_activate_licence.success', {
                                    channel: AuthorizationStore_1.default.channelId,
                                }));
                            });
                        } }))) : null),
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_UPDATE] },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "znd-assets-table-sub__button-wrapper" },
                            react_1.default.createElement(Button_1.default, { className: "justify-content-center", onClick: () => {
                                    (0, GlobalModal_1.showModal)({
                                        component: ChangeUsageInformationModal_1.default,
                                        props: {
                                            data: this.props.data,
                                            externalId: this.externalId,
                                        },
                                    });
                                }, text: this.props.t('myassets.software.btn.edit_usage.title') ?? '', variant: ButtonVariant_1.default.secondary })),
                        react_1.default.createElement("div", { className: "znd-assets-table-sub__button-wrapper" },
                            react_1.default.createElement(Button_1.default, { className: "justify-content-center", onClick: () => {
                                    (0, GlobalModal_1.showModal)({
                                        component: ChangeLicenseContactModal_1.default,
                                        props: {
                                            data: this.props.data,
                                            externalId: this.externalId,
                                        },
                                    });
                                }, text: this.props.t('myassets.software.btn.edit_license_contact.title') ?? '', variant: ButtonVariant_1.default.secondary })))))));
    }
    getSubtableLicenses(data) {
        if (!data || !data.externalId) {
            return null;
        }
        switch (data.type) {
            case ecommerce_1.MassiveLicenseTypeEnum.Option:
                return [data];
            case ecommerce_1.MassiveLicenseTypeEnum.Base:
                return [
                    data,
                    ...LicenseStore_1.default.getLicenseOfTypeForExternalId(data.externalId, ecommerce_1.MassiveLicenseTypeEnum.Option),
                    ...(data.containerNumber
                        ? LicenseStore_1.default.getLicenseOfTypeForContainerNumber(data.containerNumber, ecommerce_1.MassiveLicenseTypeEnum.Option, data.externalId)
                        : []).filter(({ activated }) => activated),
                ];
        }
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsSoftwareTableExpandedItem)));
